import { render } from "./consultationDetailed.vue?vue&type=template&id=51fa2416&scoped=true"
import script from "./consultationDetailed.vue?vue&type=script&lang=js"
export * from "./consultationDetailed.vue?vue&type=script&lang=js"

import "./consultationDetailed.vue?vue&type=style&index=0&id=51fa2416&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-51fa2416"

export default script